export default {
  init() {
    document.addEventListener('routed', e => {
      const routeName = e.detail.route;
      const routeEvent = e.detail.fn;

      console.log(routeName, routeEvent);

    });
    toggleNav();
    modalSetup();
    toggleRecs();
    toggleContacts();
    partyModal();
  },
  finalize() {
    console.log('i should run last after all the other pages finalize');
  },
};

// stop page reload

function setModalUrl(slug) {
  var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?modal=' + slug;
  window.history.pushState({path:newurl},'',newurl);
}

function clearModalUrl(){
  var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
  window.history.pushState({path:newurl},'',newurl);
}

// toggle nav

function toggleNav() {
  $("#menu-toggle").click(function() {
    $("#menu-toggle").text(($("#menu-toggle").text() == 'menu') ? 'close' : 'menu');
    if ($("nav#drop-down").css('display') == 'none'){
      $("nav#drop-down").show();
    } else {
      $("nav#drop-down").hide();
    }
  });
}

// toggle issue modal

function modalSetup() {
  $.fn.extend({
		modal: function (){
			let $handle = this.find('.modal-handle'),
				$modal = this.find('.modal'),
				$close_button = this.find('.modal-exit'),
        $modal_name = this.data('modal');
        
			$handle.on('click', function(){
				$('.modal.active').removeClass('active');
				$modal.addClass('active');
        setModalUrl($modal_name);
			});

			$close_button.on('click', function(){
				$modal.removeClass('active');
        clearModalUrl();
			})
		}
  });
  
  $('.modal-container').each(function(){ $(this).modal() })
  let activeModal = new URLSearchParams(window.location.search).get("modal");
  if(activeModal){
    let activeModalElement = $('[data-modal="'+ activeModal +'"]');
    console.log(activeModalElement);
    if(activeModalElement.length > 0){
      activeModalElement.children('div.modal').addClass('active');
    }
  } 
}

// toggle recs 

function toggleRecs() {
  $.fn.extend({
    recmodal: function (){
      let $handle = this.find('.zing-recs-modal-handle'),
        $rec_modal = this.find('.rec-modal'),
        $close_button = this.find('.modal-exit'),
        $modal_name = this.data('modal');

      $handle.on('click', function(){
        $('.rec-modal.active').removeClass('active');
        $rec_modal.addClass('active');
        setModalUrl($modal_name);
      });

      $close_button.on('click', function(){
        $rec_modal.removeClass('active');
        clearModalUrl();
      })
    }
  });
  
  $('.modal-container').each(function(){ $(this).recmodal() })
  let activeModal = new URLSearchParams(window.location.search).get("modal");
  if(activeModal){
    let activeModalElement = $('[data-modal="'+ activeModal +'"]');
    if(activeModalElement.length > 0) {
      activeModalElement.children('.rec-modal').addClass('active');
    }
  }
}


// toggle contact

function toggleContacts() {
  $.fn.extend({
		contactmodal: function (){
			let $handle = this.find('.contact-modal-handle'),
				$contact_modal = this.find('.contact-modal'),
				$close_button = this.find('.modal-exit'),
        $modal_name = this.data('modal');

			$handle.on('click', function(){
				$('.contact-modal.active').removeClass('active');
        $contact_modal.addClass('active');
        setModalUrl($modal_name);
			});

			$close_button.on('click', function(){
        $contact_modal.removeClass('active');
        clearModalUrl();
			})
		}
  });
  
  $('.modal-container').each(function(){ $(this).contactmodal() })
  let activeModal = new URLSearchParams(window.location.search).get("modal");
  if(activeModal){
    let activeModalElement = $('[data-modal="'+ activeModal +'"]');
    if(activeModalElement.length > 0) {
      activeModalElement.children('.contact-modal').addClass('active');
    }
  }
}

// toggle parties

function partyModal() {
  $.fn.extend({
		partymodal: function (){
			let $handle = this.find('.party-modal-handle'),
				$modal = this.find('#zingparty.modal'),
				$close_button = this.find('#zingparty.modal-exit'),
        $modal2_name = this.data('modal2');
        
			$handle.on('click', function(){
				$('#zingparty.modal.active').removeClass('active');
				$modal.addClass('active');
        setModalUrl($modal2_name);
      });

			$close_button.on('click', function(){
				$modal.removeClass('active');
        clearModalUrl();
			})
		}
  });
  
  $('.party-modal-container').each(function(){ $(this).partymodal() })
  let activeModal = new URLSearchParams(window.location.search).get("modal");
  if(activeModal){
    let activeModalElement = $('[data-modal2="'+ activeModal +'"]');
    if(activeModalElement.length > 0) {
      activeModalElement.children('#zingparty.modal').addClass('active');
    }
  }
}


// WEBPACK FOOTER //
// ./scripts/routes/common.js